window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.financeiro = window.FazendaRP.Pages.financeiro || {};

window.FazendaRP.Pages.financeiro.inbox = {
    // State
    items: [],
    importedKeys: new Set(),
    filterStatus: 'pendente', // pendente, todas, arquivadas
    isLoading: false,

    render: async function (container, mode = 'sefaz') {
        this.mode = mode; // 'sefaz' or 'bot'

        const isSefaz = mode === 'sefaz';
        // const title = isSefaz ? 'Notas Fiscais (SEFAZ)' : 'Inbox Bot (WhatsApp)';

        // CSS Styles for V3 Design
        const styles = `
            <style>
                .inbox-page { font-family: 'Inter', sans-serif; background: #f8fafc; padding: 20px; }
                
                /* HEADER */
                .inbox-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
                .inbox-header h1 { font-size: 1.5rem; font-weight: 700; color: #0f172a; margin: 0; display:flex; align-items:center; gap:10px; }
                
                /* STATS GRID */
                .stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 15px; margin-bottom: 25px; }
                .stat-card { background: white; padding: 15px 20px; border-radius: 12px; border: 1px solid #e2e8f0; display: flex; align-items: center; gap: 15px; box-shadow: 0 1px 2px rgba(0,0,0,0.03); }
                .stat-icon { width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; }
                .stat-info .val { font-size: 1.4rem; font-weight: 700; color: #0f172a; line-height: 1; }
                .stat-info .lbl { font-size: 0.8rem; color: #64748b; font-weight: 500; text-transform: uppercase; }

                /* CONTROLS */
                .control-bar { background: white; padding: 10px 15px; border-radius: 12px; border: 1px solid #e2e8f0; display: flex; gap: 15px; margin-bottom: 20px; align-items: center; flex-wrap: wrap; box-shadow: 0 4px 6px -4px rgba(0,0,0,0.05); }
                .search-group { flex: 1; position: relative; min-width: 200px; }
                .search-group i { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #94a3b8; }
                .search-group input { width: 100%; padding: 10px 10px 10px 35px; border-radius: 8px; border: 1px solid #e2e8f0; outline: none; transition: all 0.2s; background: #f8fafc; }
                .search-group input:focus { background: white; border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1); }

                .filter-tabs { display: flex; background: #f1f5f9; padding: 4px; border-radius: 8px; }
                .filter-tab { padding: 6px 14px; border-radius: 6px; font-size: 0.85rem; font-weight: 600; cursor: pointer; color: #64748b; transition: all 0.2s; }
                .filter-tab.active { background: white; color: #0f172a; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }

                /* LIST */
                .list-container { display: flex; flex-direction: column; gap: 10px; }
                
                .list-row { 
                    background: white; border-radius: 12px; padding: 15px 20px; 
                    display: grid; grid-template-columns: 45px 1.5fr 1fr 1fr 120px; 
                    align-items: center; gap: 20px; 
                    border: 1px solid #e2e8f0; transition: all 0.2s; cursor: pointer; position: relative;
                }
                .list-row:hover { transform: translateY(-1px); box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05); border-color: #cbd5e1; z-index:1; }

                .row-icon-box { width: 45px; height: 45px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; flex-shrink: 0; }
                .icon-whatsapp { background: #dcfce7; color: #16a34a; }
                .icon-nfe { background: #e0e7ff; color: #4338ca; }
                .icon-upload { background: #f3f4f6; color: #64748b; }

                .row-main h3 { margin: 0 0 4px 0; font-size: 0.95rem; font-weight: 600; color: #0f172a; }
                .row-main p { margin: 0; font-size: 0.8rem; color: #64748b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

                .row-meta .lbl { font-size: 0.7rem; color: #94a3b8; font-weight: 600; text-transform: uppercase; }
                .row-meta .val { font-size: 0.9rem; color: #334155; font-weight: 500; }

                .row-amount { text-align: right; font-weight: 700; font-size: 1rem; color: #0f172a; }
                
                .row-actions { display: flex; gap: 6px; justify-content: flex-end; opacity: 0; transition: opacity 0.2s; }
                .list-row:hover .row-actions { opacity: 1; }

                .btn-icon-action { width: 32px; height: 32px; border-radius: 8px; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.9rem; }
                .btn-check { background: #22c55e; color: white; }
                .btn-check:hover { background: #16a34a; transform: scale(1.1); }
                .btn-del { background: #fee2e2; color: #ef4444; }
                .btn-del:hover { background: #fecaca; transform: scale(1.1); }
                .btn-undo { background: #e2e8f0; color: #64748b; }
                
                .btn-quick-pay { background: #fee2e2; color: #ef4444; /* Fallback */ background: #fff7ed; color: #ea580c; }
                .btn-quick-pay:hover { background: #ffedd5; transform: scale(1.1); }

                .badge-origin { display: inline-flex; align-items: center; gap: 4px; padding: 2px 6px; border-radius: 4px; font-size: 0.7rem; font-weight: 600; background: #f1f5f9; color: #475569; margin-right: 6px; }
            </style>
        `;

        container.innerHTML = `
            ${styles}
            <div class="inbox-page">
                
                <!-- HEADER -->
                <div class="inbox-header">
                    <h1>
                        ${isSefaz ? '<i class="fas fa-file-invoice"></i> Notas Fiscais (SEFAZ)' : '<i class="fab fa-whatsapp" style="color:#25D366"></i> Inbox Bot'}
                    </h1>
                    <div style="display:flex; gap:10px;">
                        ${isSefaz ? `
                            <input type="file" id="xml-upload-input" multiple accept=".xml" style="display:none" onchange="window.FazendaRP.Pages.financeiro.inbox.handleXmlUpload(this)">
                            <button class="btn btn-secondary" onclick="document.getElementById('xml-upload-input').click()"><i class="fas fa-upload"></i> Upload XML</button>
                            <button id="btn-sync-sefaz" class="btn btn-primary" onclick="window.FazendaRP.Pages.financeiro.inbox.buscarNaSefaz()"><i class="fas fa-sync"></i> Sincronizar</button>
                        ` : ''}
                    </div>
                </div>

                <!-- STATS -->
                <div class="stats-grid">
                    <div class="stat-card">
                        <div class="stat-icon" style="background:#fff7ed; color:#ea580c;"><i class="fas fa-clock"></i></div>
                        <div class="stat-info">
                            <div class="lbl">Pendentes</div>
                            <div class="val" id="stat-pending-count">-</div>
                        </div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-icon" style="background:#f0fdf4; color:#16a34a;"><i class="fas fa-check-double"></i></div>
                        <div class="stat-info">
                            <div class="lbl">Processados (Mês)</div>
                            <div class="val" id="stat-imported-count">-</div>
                        </div>
                    </div>
                     ${isSefaz ? `
                        <div class="stat-card">
                             <div class="stat-icon" style="background:#eff6ff; color:#2563eb;"><i class="fas fa-certificate"></i></div>
                             <div class="stat-info">
                                <div class="lbl">Certificado</div>
                                <div class="val" id="stat-cert-status" style="font-size:1rem;">...</div>
                             </div>
                        </div>
                    ` : ''}
                </div>

                <!-- CONTROLS -->
                <div class="control-bar">
                    <div class="search-group">
                        <i class="fas fa-search"></i>
                        <input type="text" id="nfe-search" placeholder="Pesquisar por nome, valor ou descrição..." onkeyup="window.FazendaRP.Pages.financeiro.inbox.filterList()">
                    </div>
                    
                    <div class="filter-tabs">
                        <div class="filter-tab active" data-status="pendente" onclick="window.FazendaRP.Pages.financeiro.inbox.changeFilter('pendente', this)">Pendentes</div>
                        <div class="filter-tab" data-status="importado" onclick="window.FazendaRP.Pages.financeiro.inbox.changeFilter('importado', this)">Processados</div>
                        <div class="filter-tab" data-status="rejeitado" onclick="window.FazendaRP.Pages.financeiro.inbox.changeFilter('rejeitado', this)">Arquivados</div>
                        <div class="filter-tab" data-status="todas" onclick="window.FazendaRP.Pages.financeiro.inbox.changeFilter('todas', this)">Todas</div>
                    </div>
                    
                    <input type="date" id="nfe-date-start" style="border:1px solid #e2e8f0; padding:8px; border-radius:6px; color:#64748b;" onchange="window.FazendaRP.Pages.financeiro.inbox.filterList()">
                </div>

                <!-- LIST -->
                <div id="nfe-list-container" class="list-container">
                    <div style="text-align: center; padding: 40px; color: #94a3b8;">
                        <i class="fas fa-spinner fa-spin fa-2x"></i><br><br>Carregando...
                    </div>
                </div>

            </div>
        `;

        // Load Initial Data
        if (isSefaz) this.checkCertificateStatus();
        await this.loadData();
    },

    loadData: async function () {
        this.isLoading = true;
        const listDiv = document.getElementById('nfe-list-container');
        // Keep spinner if already there or add it

        try {
            // 1. Fetch Pre-Lancamentos (Inbox)
            const { data: inboxData, error: inboxError } = await window.FazendaRP.supabase
                .from('financeiro_pre_lancamentos')
                .select('*')
                .order('created_at', { ascending: false });

            if (inboxError) throw inboxError;

            // Filter locally based on Mode
            const allItems = inboxData || [];

            if (this.mode === 'sefaz') {
                this.items = allItems.filter(i => ['nuvem_fiscal_api', 'sefaz_visual', 'xml_dfe'].includes(i.origem_tipo));
            } else {
                // Bot (Everything else: whatsapp, manual, fluxobot, etc.)
                this.items = allItems.filter(i => !['nuvem_fiscal_api', 'sefaz_visual', 'xml_dfe'].includes(i.origem_tipo));
            }

            // 2. Fetch Existing Keys for Duplicate Check (Last 6 months to be safe/perf)
            // Querying 'detalhes' column is expensive if not indexed properly, but needed.
            // Actually, we can just fetch ALL valid keys from details.
            // Optimization: Only fetch keys that match our inbox items? No, easier to fetch recent lancamentos.

            const { data: existingKeys, error: keyError } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('detalhes')
                .neq('status', 'Cancelado')
                .limit(2000) // Safety limit
                .order('created_at', { ascending: false });

            this.importedKeys = new Set();
            if (existingKeys) {
                existingKeys.forEach(row => {
                    if (row.detalhes && row.detalhes.chave_nfe) {
                        this.importedKeys.add(row.detalhes.chave_nfe);
                    }
                    // Compatibility: Maybe check num_doc + emitente?
                    // For now, rely on Key.
                });
            }

            this.isLoading = false;
            this.renderList();
            this.updateStats();

            // Check for pending actions from Dashboard
            setTimeout(() => this.checkPendingBotAction(), 300);

        } catch (e) {
            console.error(e);
            if (listDiv) listDiv.innerHTML = `<div class="alert alert-danger">Erro ao carregar dados: ${e.message}</div>`;
        }
    },

    renderList: function () {
        const listDiv = document.getElementById('nfe-list-container');
        if (!listDiv) return;

        const term = document.getElementById('nfe-search')?.value.toLowerCase() || '';
        const statusFilter = this.filterStatus;
        const dateStart = document.getElementById('nfe-date-start')?.value;
        const dateEnd = document.getElementById('nfe-date-end')?.value;

        const filtered = this.items.filter(item => {
            const d = item.dados_extraidos || {};

            // Search Filter
            const searchMatch = (d.empresa || '').toLowerCase().includes(term) ||
                (d.descricao || '').toLowerCase().includes(term) ||
                (d.chave || '').toLowerCase().includes(term) ||
                (item.id.toString().includes(term)) ||
                (item.texto_bruto || '').toLowerCase().includes(term);

            // Date Filter (YYYY-MM-DD from 'data')
            let dateMatch = true;
            if (d.data) {
                const itemDate = d.data.includes('T') ? d.data.split('T')[0] : d.data;
                if (dateStart && itemDate < dateStart) dateMatch = false;
                if (dateEnd && itemDate > dateEnd) dateMatch = false;
            }

            // Status Logic
            const isAlreadyImported = d.chave ? this.importedKeys.has(d.chave) : false;

            let statusMatch = false;
            if (statusFilter === 'todas') statusMatch = true;
            else if (statusFilter === 'rejeitado') statusMatch = item.status === 'rejeitado';
            else if (statusFilter === 'importado') statusMatch = (item.status === 'aprovado' || isAlreadyImported);
            else if (statusFilter === 'pendente') statusMatch = (item.status === 'pendente' && !isAlreadyImported);

            return searchMatch && dateMatch && statusMatch;
        });

        if (filtered.length === 0) {
            listDiv.innerHTML = `
                <div style="text-align: center; padding: 60px;">
                    <i class="fas fa-search" style="color: #cbd5e1; font-size: 3em; margin-bottom: 20px;"></i>
                    <h3 style="color: #64748b; font-size:1.1rem; margin:0;">Nenhum item encontrado</h3>
                    <p style="color: #94a3b8; font-size:0.9rem;">Ajuste os filtros ou verifique a conexão.</p>
                </div>
            `;
            return;
        }

        listDiv.innerHTML = filtered.map(item => this.renderRow(item)).join('');
    },

    renderRow: function (item) {
        const d = item.dados_extraidos || {};

        // 🔧 FIX: Handle nested structure from WhatsApp/Audio bot
        // Bot saves: { tipo: "FINANCEIRO", dados: { valor, descricao, ... } }
        // NFe saves directly: { valor, empresa, descricao, ... }
        const isBotEntry = (item.origem_tipo === 'whatsapp' || item.origem_tipo === 'whatsapp_audio') && d.dados;
        const data = isBotEntry ? d.dados : d;

        const isImported = item.status === 'aprovado' || (d.chave && this.importedKeys.has(d.chave));
        const isRejeitado = item.status === 'rejeitado';

        // ... (formatting logic) ...
        const valorFmt = data.valor ? parseFloat(data.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00';

        let dataFmt = '-';
        let horaFmt = '';
        if (data.data || d.data) {
            const dateSource = data.data || d.data;
            const dateObj = new Date(dateSource);
            if (!isNaN(dateObj.getTime())) {
                dataFmt = dateObj.toLocaleDateString('pt-BR');
                if (dateSource.includes('T')) horaFmt = dateObj.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
            } else {
                dataFmt = dateSource;
            }
        }

        // Icon Logic
        let iconClass = 'fa-file-invoice';
        let boxClass = 'icon-nfe';
        if (item.origem_tipo === 'whatsapp' || item.origem_tipo === 'whatsapp_audio') {
            iconClass = 'fa-whatsapp';
            boxClass = 'icon-whatsapp';
        } else if (item.origem_tipo === 'upload_manual') {
            iconClass = 'fa-upload';
            boxClass = 'icon-upload';
        }

        const titleMain = data.fornecedor || data.empresa || d.empresa || 'Desconhecido';
        const subTitle = data.descricao || d.descricao || 'Sem descrição';

        let badgeOrigin = '';
        if (item.origem_tipo === 'whatsapp' || item.origem_tipo === 'whatsapp_audio') {
            const audioIcon = item.origem_tipo === 'whatsapp_audio' ? '<i class="fas fa-microphone"></i>' : '<i class="fab fa-whatsapp"></i>';
            badgeOrigin = `<span class="badge-origin">${audioIcon} Bot</span>`;
        }
        if (['xml_dfe', 'nuvem_fiscal_api', 'sefaz_visual'].includes(item.origem_tipo)) badgeOrigin = `<span class="badge-origin" style="background:#eff6ff; color:#1d4ed8;"><i class="fas fa-cloud"></i> NFe</span>`;

        // Actions Logic
        let actions = '';
        if (isRejeitado) {
            actions = `
                 <button class="btn-icon-action btn-undo" onclick="window.FazendaRP.Pages.financeiro.inbox.restaurar('${item.id}')" title="Restaurar">
                     <i class="fas fa-undo"></i>
                 </button>
             `;
        } else if (isImported) {
            // Always show eye button for imported items
            const viewButton = `<button class="btn-icon-action btn-view" onclick="window.FazendaRP.Pages.financeiro.inbox.viewCreatedLancamento('${item.lancamento_gerado_id || ''}', '${item.id}')" title="Ver Lançamento Criado">
                    <i class="fas fa-eye"></i>
                </button>`;

            actions = `
                <span style="color:#16a34a; font-size:0.9rem; font-weight:600;"><i class="fas fa-check-double"></i> Importado</span>
                ${viewButton}
             `;
        } else {
            // Pending
            // JSON.stringify for item passthrough might be tricky with quotes. Using ID lookup instead.
            // But for now, let's keep it simple and just pass ID.
            actions = `
                 <button class="btn-icon-action btn-del" onclick="window.FazendaRP.Pages.financeiro.inbox.rejeitar('${item.id}')" title="Arquivar">
                     <i class="fas fa-times"></i>
                 </button>
                 <button class="btn-icon-action btn-quick-pay" onclick="window.FazendaRP.Pages.financeiro.inbox.openQuickPay('${item.id}')" title="Pagamento Rápido">
                     <i class="fas fa-bolt"></i>
                 </button>
                 <button class="btn-icon-action btn-check" onclick="window.FazendaRP.Pages.financeiro.inbox.aprovar('${item.id}')" title="Lançar Completo">
                     <i class="fas fa-check"></i>
                 </button>
             `;
        }

        return `
            <div class="list-row">
                <div class="row-icon-box ${boxClass}">
                    <i class="fab ${iconClass}"></i>
                </div>
                <div class="row-main">
                    <h3>${titleMain}</h3>
                    <p>${badgeOrigin} ${subTitle}</p>
                </div>
                <div class="row-meta">
                    <div class="lbl">Data</div>
                    <div class="val">${dataFmt} ${horaFmt}</div>
                </div>
                <div class="row-amount">
                    ${valorFmt}
                </div>
                <div class="row-actions">
                    ${actions}
                </div>
            </div>
        `;
    },

    // ... (Filter functions) ...

    openQuickPay: async function (id) {
        const item = this.items.find(i => i.id === id);
        if (!item) return;

        const d = item.dados_extraidos || {};
        // 🔧 FIX: Handle nested structure from bot
        const isBotEntry = (item.origem_tipo === 'whatsapp' || item.origem_tipo === 'whatsapp_audio') && d.dados;
        const data = isBotEntry ? d.dados : d;

        // Prepare prefill data for Transfer Modal
        const prefill = {
            data: (data.data || d.data) ? ((data.data || d.data).includes('T') ? (data.data || d.data).split('T')[0] : (data.data || d.data)) : new Date().toISOString().split('T')[0],
            valor: data.valor ? parseFloat(data.valor) : 0,
            obs: `${data.fornecedor || data.empresa || d.empresa || 'Bot'} - ${data.descricao || d.descricao || ''}`,
            tipo_trf: 'externa', // Default to external payment
            preventRedirect: true // Don't reload Movimentações after save
        };

        // Call the same modal function used in Movimentações
        const result = await window.FazendaRP.Pages.financeiro.renderTransferenciaModal(prefill);

        // ✅ ONLY mark as approved if user actually saved
        if (result) {
            await window.FazendaRP.supabase
                .from('financeiro_pre_lancamentos')
                .update({
                    status: 'aprovado',
                    lancamento_gerado_id: result.lancamento_id || null
                })
                .eq('id', id);

            window.FazendaRP.Toast.show('success', 'Processado!', 'Pagamento registrado.');
        } else {
            window.FazendaRP.Toast.show('info', 'Cancelado', 'Operação cancelada.');
        }

        this.loadData(); // Reload inbox
    },




    changeFilter: function (status, element) {
        this.filterStatus = status;

        // Update Tabs UI
        if (element) {
            document.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
            element.classList.add('active');
        } else {
            // If called pragmatically, try to find by data-status
            document.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
            const target = document.querySelector(`.filter-tab[data-status="${status}"]`);
            if (target) target.classList.add('active');
        }

        this.renderList();
    },

    filterList: function () {
        this.renderList();
    },

    checkCertificateStatus: async function () {
        const el = document.getElementById('stat-cert-status');
        if (!el) return;

        try {
            const { data } = await window.FazendaRP.supabase
                .from('config_certificados')
                .select('*')
                .eq('ativo', true)
                .order('data_upload', { ascending: false })
                .limit(1)
                .maybeSingle();

            if (data) {
                el.innerHTML = `<i class="fas fa-check-circle"></i> Ativo`;
                el.style.color = '#16a34a';
            } else {
                el.innerHTML = `<i class="fas fa-exclamation-triangle"></i> Não configurado`;
                el.style.color = '#f59e0b';
            }
        } catch (e) {
            el.innerHTML = 'Erro';
        }
    },

    updateStats: function () {
        // Simple counts based on loaded buffer
        const pending = this.items.filter(i => i.status === 'pendente').length;

        const elPending = document.getElementById('stat-pending-count');
        if (elPending) elPending.innerText = pending;

        // Imported this month (mock logic or count approved)
        const imported = this.items.filter(i => i.status === 'aprovado').length;

        const elImported = document.getElementById('stat-imported-count');
        if (elImported) elImported.innerText = imported;
    },

    // ACTIONS
    aprovar: async function (id) {
        const item = this.items.find(i => i.id === id);
        if (!item) return;

        try {
            // FIX: "Novo Lançamento" não tem aba no menu principal, então chamamos direto.
            // 1. Atualizar UI de abas (Visualmente fica em Lançamentos ou Sefaz? Vamos deixar Lançamentos ativo).
            const tabs = document.querySelectorAll('.submenu-item');
            tabs.forEach(t => t.classList.remove('active'));
            document.querySelector('.submenu-item[data-tab="lancamentos"]')?.classList.add('active');

            // 2. Renderizar tela de Novo Lançamento
            const content = document.getElementById('financeiro-content');
            // Check if core function exists
            if (window.FazendaRP.Pages.financeiro.renderTabContent) {
                window.FazendaRP.Pages.financeiro.renderTabContent('novo-lancamento');
            } else {
                console.error("Função renderTabContent não encontrada");
                return;
            }

            const d = item.dados_extraidos || {};

            // 3. Preencher formulário após renderização
            setTimeout(() => {
                // 🔧 FIX: Handle nested structure from bot
                const isBotEntry = (item.origem_tipo === 'whatsapp' || item.origem_tipo === 'whatsapp_audio') && d.dados;
                const data = isBotEntry ? d.dados : d;

                // Description & Enterprise
                const descInput = document.getElementById('desc-sem-itens');
                if (descInput) descInput.value = (data.fornecedor || data.empresa || d.empresa ? (data.fornecedor || data.empresa || d.empresa) + " - " : "") + (data.descricao || d.descricao || "");

                // Date
                const dateInput = document.getElementById('data-emissao');
                const dateSource = data.data || d.data;
                if (dateInput && dateSource) {
                    // Ensure format YYYY-MM-DD
                    const isoDate = dateSource.includes('T') ? dateSource.split('T')[0] : dateSource;
                    dateInput.value = isoDate;
                }

                // Value
                const valInput = document.getElementById('valor-total-sem-itens');
                if (valInput && data.valor) {
                    const v = parseFloat(data.valor);
                    valInput.value = 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                }

                // ID PRE-LAUNCH & KEY
                const form = document.getElementById('form-lancamento');
                if (form) {
                    form.dataset.preLancamentoId = id;

                    // Attach Hidden Key Input for CRUD to save
                    let keyInput = document.getElementById('chave-nfe-hidden');
                    if (!keyInput) {
                        keyInput = document.createElement('input');
                        keyInput.type = 'hidden';
                        keyInput.id = 'chave-nfe-hidden';
                        form.appendChild(keyInput);
                    }
                    keyInput.value = d.chave || '';

                    // Banner
                    const existingBanner = form.querySelector('.alert-info');
                    if (!existingBanner) {
                        const banner = document.createElement('div');
                        banner.className = 'alert alert-info';
                        banner.innerHTML = `<i class="fab fa-whatsapp"></i> <strong>Importando:</strong> ${d.empresa || 'Documento'}`;
                        form.prepend(banner);
                    }
                }
            }, 600);

        } catch (e) {
            console.error(e);
            alert("Erro ao abrir formulário: " + e.message);
        }
    },

    rejeitar: async function (id) {
        if (!confirm("Arquivar esta nota?")) return;
        const { error } = await window.FazendaRP.supabase
            .from('financeiro_pre_lancamentos')
            .update({ status: 'rejeitado' })
            .eq('id', id);

        if (!error) {
            window.FazendaRP.Toast.show('success', 'Arquivado', 'Nota removida da caixa de entrada.');
            this.loadData();
        }
    },

    restaurar: async function (id) {
        // Move back to 'pendente'
        const { error } = await window.FazendaRP.supabase
            .from('financeiro_pre_lancamentos')
            .update({ status: 'pendente' })
            .eq('id', id);

        if (!error) {
            window.FazendaRP.Toast.show('success', 'Restaurado', 'Nota voltou para a lista de pendentes.');
            this.loadData();
        }
    },

    marcarResolvido: async function (id) {
        // Mark as approved (linked via duplicate check)
        // Find the existing ID?
        const item = this.items.find(i => i.id === id);
        const d = item.dados_extraidos || {};

        // Try to find the Linked ID from my cache (not perfect but OK)
        // ideally update backend with real link? 
        // For now just set status 'aprovado'.

        const { error } = await window.FazendaRP.supabase
            .from('financeiro_pre_lancamentos')
            .update({ status: 'aprovado', observacao: 'Resolvido via Duplicidade Detectada' })
            .eq('id', id);

        if (!error) {
            window.FazendaRP.Toast.show('success', 'Limpo', 'Nota marcada como importada.');
            this.loadData();
        }
    },

    viewCreatedLancamento: async function (lancamentoId, preLancamentoId) {
        try {
            let finalLancamentoId = lancamentoId;

            // If no direct ID, fetch it from pre_lancamentos table
            if (!finalLancamentoId && preLancamentoId) {
                const { data: preLanc, error } = await window.FazendaRP.supabase
                    .from('financeiro_pre_lancamentos')
                    .select('lancamento_gerado_id')
                    .eq('id', preLancamentoId)
                    .maybeSingle();

                if (error) {
                    console.error('Erro ao buscar pre_lancamento:', error);
                }

                if (preLanc && preLanc.lancamento_gerado_id) {
                    finalLancamentoId = preLanc.lancamento_gerado_id;
                }
            }

            if (!finalLancamentoId) {
                window.FazendaRP.Toast.show('warning', 'Não Encontrado', 'Lançamento não foi vinculado a este item do inbox. Tente buscar manualmente na aba Lançamentos.');
                return;
            }

            // Navigate to lancamentos tab and open the lancamento in edit/view mode
            const tabs = document.querySelectorAll('.submenu-item');
            tabs.forEach(t => t.classList.remove('active'));
            document.querySelector('.submenu-item[data-tab="lancamentos"]')?.classList.add('active');

            // Load the lancamento for viewing
            if (window.FazendaRP.LancamentosCRUD && window.FazendaRP.LancamentosCRUD.loadLancamentoForEdit) {
                await window.FazendaRP.LancamentosCRUD.loadLancamentoForEdit(finalLancamentoId, { readOnly: true });
            } else {
                window.FazendaRP.Toast.show('error', 'Erro', 'Módulo de lançamentos não encontrado.');
            }
        } catch (err) {
            console.error('Erro ao buscar lançamento:', err);
            window.FazendaRP.Toast.show('error', 'Erro', 'Erro ao buscar lançamento: ' + err.message);
        }
    },

    buscarNaSefaz: async function () {
        const btn = document.getElementById('btn-sync-sefaz');
        if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Buscando...'; }

        try {
            // FRONTEND: Apenas recarrega a lista
            // A sincronização real é feita pelo Node.js (worker_nfe.js) no servidor/background.

            console.log("Solicitando atualização da Inbox...");

            // Opcional: Aqui poderíamos chamar um endpoint backend para disparar o worker sob demanda.
            // Por enquanto, apenas recarrega o que o worker já inseriu.

            await new Promise(r => setTimeout(r, 800)); // Pequeno delay visual

            window.FazendaRP.Toast.show('info', 'Sincronização', 'Inbox atualizada. Verifique se o Robô de NFe está rodando.');
            this.loadData();

        } catch (e) {
            console.error("Erro ao atualizar inbox:", e);
            window.FazendaRP.Toast.show('error', 'Erro', e.message);
        } finally {
            if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fas fa-robot"></i> Buscar na SEFAZ'; }
        }
    },
    handleXmlUpload: async function (input) {
        if (!input.files || input.files.length === 0) return;

        const files = Array.from(input.files);
        let imported = 0;
        let errors = 0;

        window.FazendaRP.Toast.show('info', 'Importando...', `Lendo ${files.length} arquivos XML...`);

        for (const file of files) {
            try {
                const text = await file.text();
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(text, "text/xml");

                // Basic Validation
                const infNFe = xmlDoc.getElementsByTagName("infNFe")[0];
                if (!infNFe) {
                    console.warn(`Arquivo ${file.name} não parece ser uma NFe válida.`);
                    errors++;
                    continue;
                }

                // Extract Fields
                const chave = infNFe.getAttribute("Id")?.replace('NFe', '') || '';
                const emit = xmlDoc.getElementsByTagName("emit")[0];
                const ide = xmlDoc.getElementsByTagName("ide")[0];
                const total = xmlDoc.getElementsByTagName("total")[0];

                const nomeEmitente = emit?.getElementsByTagName("xNome")[0]?.textContent || 'Desconhecido';
                const cnpjEmitente = emit?.getElementsByTagName("CNPJ")[0]?.textContent || '';
                const dhEmi = ide?.getElementsByTagName("dhEmi")[0]?.textContent || ide?.getElementsByTagName("dEmi")[0]?.textContent || new Date().toISOString();
                const vNF = total?.getElementsByTagName("vNF")[0]?.textContent || '0.00';

                // Check Duplicates in Pre-Launch
                // (Optional: Client-side check against loaded list to save API calls?)
                // Better: Do `upsert` or check existing. 'insert' will duplicate if no unique constraint on content.
                // We rely on `dados_extraidos->>chave` logic in worker, let's replicate here ideally or just insert and let user manage.
                // Let's emulate the Worker logic: Check existence first.

                const { data: existing } = await window.FazendaRP.supabase
                    .from('financeiro_pre_lancamentos')
                    .select('id')
                    .filter('dados_extraidos->>chave', 'eq', chave)
                    .maybeSingle();

                if (existing) {
                    console.log(`Nota ${chave} já existe no Inbox.`);
                    continue; // Skip without error
                }

                // Prepare Payload
                const dadosExtraidos = {
                    tipo: 'NFe',
                    chave: chave,
                    empresa: nomeEmitente,
                    emitente_cnpj: cnpjEmitente,
                    data: dhEmi,
                    valor: parseFloat(vNF),
                    itens: [] // Could extract items later if needed for intelligence
                };

                // Insert
                const { error } = await window.FazendaRP.supabase.from('financeiro_pre_lancamentos').insert([{
                    origem_tipo: 'upload_manual', // Marks it as manually uploaded
                    origem_id: 'manual_' + Date.now(),
                    tipo_arquivo: 'xml_dfe',
                    texto_bruto: text, // Save full XML
                    status: 'pendente',
                    dados_extraidos: dadosExtraidos
                }]);

                if (error) throw error;
                imported++;

            } catch (err) {
                console.error(`Erro ao importar ${file.name}:`, err);
                errors++;
            }
        }

        // Reset Input
        input.value = '';

        // Feedback
        if (imported > 0) {
            window.FazendaRP.Toast.show('success', 'Importação Concluída', `${imported} notas importadas com sucesso.`);
            this.loadData(); // Refresh List
        } else if (errors > 0) {
            window.FazendaRP.Toast.show('error', 'Erro na Importação', 'Não foi possível importar os arquivos selecionados. Verifique se são XMLs de NFe válidos.');
        } else {
            window.FazendaRP.Toast.show('info', 'Sem Novidades', 'Nenhuma nota nova importada (duplicadas ou inválidas).');
        }
    },

    checkPendingBotAction: async function () {
        const raw = localStorage.getItem('bot_action_pending');
        if (!raw) return;

        try {
            const { action, id } = JSON.parse(raw);
            localStorage.removeItem('bot_action_pending'); // Consumed

            // Find item
            const item = this.items.find(i => i.id === id);

            if (item) {
                if (action === 'aprovar') {
                    window.FazendaRP.Toast.show('info', 'Assistente IA', 'Abrindo lançamento para aprovação...');
                    this.aprovar(id);
                }
                if (action === 'pagar') {
                    window.FazendaRP.Toast.show('info', 'Assistente IA', 'Abrindo pagamento rápido...');
                    this.openQuickPay(id);
                }
            } else {
                console.warn("Item do bot não encontrado na lista offline:", id);
                // Fallback: maybe fetch specific item?
            }
        } catch (e) { console.error("Erro ao processar ação do bot:", e); }
    }

}; // End Object
